import { render, staticRenderFns } from "./ReceivePayment.vue?vue&type=template&id=7cc00195&"
import script from "./ReceivePayment.vue?vue&type=script&lang=ts&"
export * from "./ReceivePayment.vue?vue&type=script&lang=ts&"
import style0 from "./ReceivePayment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports